import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { ProductFormService } from "../shared";

@Component({
  selector: "product-software-form",
  templateUrl: "./product-software-form.component.html",
  styleUrls: ["./product-software-form.component.scss"],
})
export class ProductSoftwareFormComponent {
  @Input() form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public formService: ProductFormService
  ) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-software-form/product-software-form.component.ts